import { useTranslations } from '@/lib/next-shim'
import { GetMyInfosQuery } from '@/core/graphql/types'
import { FormSubmissionsList } from '@/shared/ui/form/FormSubmissionsList'

type FormSubmissionsSectionProps = {
  submissions: GetMyInfosQuery['myInfos']['formSubmissions']
  contextType: 'consultation' | 'expertise'
  contextId: string
}

export function FormSubmissionsSection({ submissions, contextType, contextId }: FormSubmissionsSectionProps) {
  const t = useTranslations()

  return (
    <section className="flex flex-col gap-2 w-full">
      <h3 className="section-title">{t('page.forms.submission.title')}</h3>
      <div className="shadow bg-white rounded-lg p-4 md:p-5">
        <FormSubmissionsList submissions={submissions} contextType={contextType} contextId={contextId} />
      </div>
    </section>
  )
}
